import React from "react";

import MDBox from "../../../materialDashboard/components/MDBox";
import MDAvatar from "../../../materialDashboard/components/MDAvatar";
import MDTypography from "../../../materialDashboard/components/MDTypography";



const UserCol = ({user}) => {
    if (!user) {
        return null;
    }

    const {name, surname, email, image} = user;

    return <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={image} name={name} size="sm" bgColor={"secondary"}/>
        <MDBox ml={2} lineHeight={1}>
            <MDTypography display="block" variant="button" fontWeight="medium">
                {surname} {name}
            </MDTypography>
            <MDTypography variant="caption">{email}</MDTypography>
        </MDBox>
    </MDBox>;
}

export default UserCol;
